import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../css/contactCard.css';
import {Button} from "antd";

const ContactCard = ({ data }) => {
    const navigate = useNavigate();
    const { title, description, linkButton, background } = data;

    const handleButtonClick = (slug) => {
        navigate(slug);
    };

    return (
        <div
            className="contact-card"
            style={{ backgroundImage: `url(${background.data.attributes.url})` }}
        >
            <div className="contact-card-content">
                <h3 className="contact-card-title">{title}</h3>
                <p className="contact-card-desc">{description}</p>
                <div className="contact-card-buttons">
                    {linkButton.map((button, index) => (
                        <Button
                            key={index}
                            className={`contact-card-button ${button.isUnderLine ? 'underline' : ''}`}
                            onClick={() => handleButtonClick(button.slug)}
                        >
                            {button.title}
                        </Button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ContactCard;
